import { render, staticRenderFns } from "./Billings.vue?vue&type=template&id=0f3ad510&scoped=true&"
import script from "./Billings.vue?vue&type=script&lang=js&"
export * from "./Billings.vue?vue&type=script&lang=js&"
import style0 from "./Billings.vue?vue&type=style&index=0&id=0f3ad510&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3ad510",
  null
  
)

export default component.exports